import { useAuth } from "../AuthContext";
import { useEffect, useRef } from "react";

export const LoginPage = () => {
	const { login } = useAuth();
	// signinRedirect() navigates on its own; firing it twice under StrictMode
	// starts a second authorization round-trip that invalidates the first.
	const redirectStarted = useRef(false);

	useEffect(() => {
		if (redirectStarted.current) return;
		redirectStarted.current = true;
		login();
	}, [login]);

	return (
		<div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-app)]">
			<div className="text-center">
				<div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent)] border-t-transparent mx-auto"></div>
				<p className="mt-4 text-[var(--color-text-secondary)]">
					Redirecting to login...
				</p>
			</div>
		</div>
	);
};
